import type { RateLineFlags } from '../pages/Admin/Pricing/types'

// A fresh rate line. scope DELIVERY is what every line was before 20261003; callers pick CONTAINER for a card without a delivery method.
export const blankLineFlags = (): RateLineFlags => ({
  scope: 'DELIVERY', period_unit: null, free_qty: null, free_unit: null, is_at_cost: false, is_optional: false, is_enabled: true,
})
